import { Box, Input, TextField, Typography } from '@mui/material'
import React from 'react'
import { ProvidersMetricsFilterWrapper } from './Atom'
import SearchIcon from '@mui/icons-material/Search';
import { ColumnFilterMenu } from '../../Menu';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { setFilteredProviderMetrics } from '../../../redux/slices/providersSlice';

type Props = {}

const ProvidersMetricsFilter = (props: Props) => {

    const dispatch = useDispatch();

    const allProviderMetrics = useSelector((state: any) => {
        return state.providers.allProviderMetrics
    })

    const handleProviderMetricsSearch = (value: any) => {
        dispatch(setFilteredProviderMetrics(allProviderMetrics?.filter((metric: any) => metric?.metric_name?.toLowerCase()?.includes(value?.toLowerCase()))));
    }


    return (
        <ProvidersMetricsFilterWrapper>
            <SearchIcon sx={{ fontSize: "20px" }} />
            <Input
                placeholder="Search"
                sx={{ marginLeft: "10px", fontSize: "14px" }}
                onChange={(e: any) => handleProviderMetricsSearch(e.target.value)}
            />
            <ColumnFilterMenu />
        </ProvidersMetricsFilterWrapper>
    )
}

export default ProvidersMetricsFilter